import HowToSetUpSkeleton from 'components/features-page/HowToSetUpSkeleton'
import { graphql, useStaticQuery } from 'gatsby'
import { ReactElement } from 'react'
import { ThemeUIStyleObject } from 'theme-ui'
import getEnglishStrings from 'utils/getEnglishStrings'

export default function MobileHowToSetUp({
  sxx,
  path,
}: {
  sxx?: ThemeUIStyleObject
  path: string
}): ReactElement {
  const howToSetUpData = useStaticQuery<Queries.MobileHowToSetUpQuery>(graphql`
    query MobileHowToSetUp {
      directus {
        general_translations {
          strings {
            languages_code {
              code
            }
            id
            get_the_app
            sign_up
            connect
          }
        }
        ios_app_page {
          strings {
            languages_code {
              code
            }
            how_to_set_up
            get_the_app
            sign_up
            connect
          }
        }
        android_app_page {
          strings {
            languages_code {
              code
            }
            how_to_set_up
            get_the_app
            sign_up
            connect
          }
        }
      }
    }
  `)

  const generalTranslations = getEnglishStrings(
    howToSetUpData?.directus?.general_translations?.strings,
  )

  const setupData = {
    '/features/android/': getEnglishStrings(howToSetUpData?.directus?.android_app_page?.strings),
    '/features/ios/': getEnglishStrings(howToSetUpData?.directus?.ios_app_page?.strings),
  }[path]

  return (
    <HowToSetUpSkeleton
      sxx={sxx}
      title={setupData?.how_to_set_up ?? ''}
      items={[
        {
          title: generalTranslations?.get_the_app ?? '-',
          subtitle: setupData?.get_the_app ?? '',
          order: 1,
        },
        {
          title: generalTranslations?.sign_up ?? '',
          subtitle: setupData?.sign_up ?? '',
          order: 2,
        },
        {
          title: generalTranslations?.connect ?? '',
          subtitle: setupData?.connect ?? '',
          order: 3,
        },
      ]}
    />
  )
}
